const NOTIFICATION_TIMEOUT_SHORT = 4000 // in ms
const NOTIFICATION_TIMEOUT_LONG = 8000 // in ms

export {
  NOTIFICATION_TIMEOUT_SHORT,
  NOTIFICATION_TIMEOUT_LONG,
}
